<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <n-divide class="table-tools">
      <div></div>
      <n-link v-if="edit.records" :to="createRecordLink()"><n-button>Создать запись</n-button></n-link>
    </n-divide>

    <n-table :columns="columns" :data="data">
      <template #headerRow>
        <tr class="header">
          <td>Дата выполнения работ, смена</td>
          <td>Наименование соединяемых элементов; марка стали</td>
          <td>Место или номер (по чертежу или схеме) свариваемого элемента</td>
          <td>Отметка о сдаче и приемке узла под сварку (должность, фамилия, инициалы, подпись)</td>
          <td>Марка применяемых сварочных материалов (проволока, флюс, электроды), номер партии</td>
          <td>Атмосферные условия (температура воздуха, осадки, скорость ветра)</td>
          <td>Фамилия, инициалы сварщика, номер удостоверения</td>
          <td>Клеймо</td>
          <td>Подписи сварщиков, сваривающих соединения</td>
          <td>Фамилия, инициалы ответственного за производство работ (мастера, производителя работ)</td>
          <td>Отметка о приемке сварного соединения</td>
          <td>Подпись руководителя сварочных работ</td>
          <td>Замечания по контрольной проверке (производителя работ и др.)</td>
          <td></td>
        </tr>
        <tr class="header">
          <td>1</td>
          <td>2</td>
          <td>3</td>
          <td>4</td>
          <td>5</td>
          <td>6</td>
          <td>7</td>
          <td>8</td>
          <td>9</td>
          <td>10</td>
          <td>11</td>
          <td>12</td>
          <td>13</td>
          <td></td>
        </tr>
      </template>
      <template #recordsSign="{item}">
        <c-journal-sign :sign="getSign(item, 'records')" />
      </template>
      <template #recordsFinishSign="{item}">
        <c-journal-sign :sign="getSign(item, 'recordsFinal')" />
      </template>
      <template #welderTitle="{item}">
        {{ getSignTitle(item, 'welding') }}
      </template>
      <template #welderSign="{item}">
        <c-journal-sign :sign="getSign(item, 'welding')" only-qr />
      </template>
      <template #masterSign="{item}">
        <c-journal-sign :sign="getSign(item, 'master')" />
      </template>
      <template #date="{item}">
        {{ $app.date.format(item.publishedAt) }}<br />
        {{ item.date }}
      </template>
      <template #tools="{item}">
        <n-link :to="showRecordLink(item.id)"><n-button icon="eye" /></n-link>
      </template>
    </n-table>

    <page-record-create v-if="newRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(createRecordLink(false))" />
    <modal-record v-if="showRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(showRecordLink(false))" />
  </div>
</template>

<script>
import PageRecordCreate from './Create'
import ModalRecord from './record/Index'
import utils from 'utils'
import CJournalSign from 'components/journal/Sign'

export default {
  name: 'MainChapter4',
  components: { ModalRecord, PageRecordCreate, CJournalSign, },
  props: [ 'project', 'journal', ],
  data: () => ({
    utils,
    data: [
    ],
  }),
  computed: {
    newRecord() {
      return this.$route.query['new'] !== undefined
    },
    showRecord() {
      return this.$route.query['show'] !== undefined
    },
    edit() {
      return {
        records: $app.auth.can('journals_welding_records', this.project.id),
      }
    },
    columns() {
      return [
        { name: 'date', title: '', },
        { name: 'title', title: '', },
        { name: 'place', title: '', },
        { name: 'recordsSign', title: '', },
        { name: 'brand', title: '', },
        { name: 'weather', title: '', },
        { name: 'welderTitle', title: '', },
        { name: 'stigma', title: '', },
        { name: 'welderSign', title: '', },
        { name: 'masterSign', title: '', },
        { name: 'mark', title: '', },
        { name: 'recordsFinishSign', title: '', },
        { name: 'remark', title: '', },
        { name: 'tools', title: '', },
      ]
    },
  },
  watch: {
    project() {
      this.load()
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, 'welding')
        .query({
          'with[author][with][participation]': null,
          'with[signs][with][author]': null,
          projectId: this.project.id,
        })
        .then((response) => {
          this.data = response.data.content
        }).finally(() => {
          this.$var('load', false)
        })
    },
    getUser(item, name) {
      if (!item[name]) {
        return ''
      }
      return item[name]?.participation?.position + ', ' + item[name]?.fullName
    },
    createRecordLink(open = true) {
      return { query: { ...this.$route.query, 'new': open ? null : undefined, }, }
    },
    showRecordLink(open) {
      return { query: { ...this.$route.query, 'show': open || undefined, }, }
    },
    getSign(item, name) {
      return $n.find(item.signs, [ 'name', name, ])
    },
    getSignTitle(item, name) {
      const author = this.getSign(item, name)?.author || { position: '', fullName: '', }
      return author.position + ' ' + author.fullName
    },
  },
}
</script>

<style lang="scss" scoped>
.main-chapter1 {

}
</style>
